import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Button, Hyperlink } from "@ebsco-ui/ebsco-ui";
import { EBSCO_URLS } from "../../../../../constants";
import { clearResetPasswordState } from "../../../../store/password/reset";
import messages from "./recovery-controls-messages";

import "./recovery-controls.scss";

const block = "recovery-controls";

const RecoveryControls = ({ clearResetPasswordState }) => {
  const tryAgain = () => {
    clearResetPasswordState();
  };

  return (
    <div className={block}>
      <span className={`${block}__retry-message`}>
        <FormattedMessage
          {...messages.tryAgain}
          values={{
            button: displayButton(block, tryAgain)
          }}
        />
      </span>
      <span className={`${block}__help-message`}>
        <FormattedMessage
          {...messages.contactCustomerHelp}
          values={{
            a: displayLink(block)
          }}
        />
      </span>
    </div>
  );
};

const displayButton = (block, tryAgain) => msg => (
  <Button
    type="button"
    styleType="link"
    className={`${block}__retry-button`}
    onClick={tryAgain}
  >
    {msg}
  </Button>
);

const displayLink = block => msg => (
  <Hyperlink
    className={`${block}__help-link`}
    href={EBSCO_URLS.HELP_URL}
    target="_blank"
  >
    {msg}
  </Hyperlink>
);

const mapDispatchToProps = { clearResetPasswordState };

export { RecoveryControls };
export default connect(null, mapDispatchToProps)(RecoveryControls);
